<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
			body: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div
	use:editable={content}
	class="absolute m-3 lg:m-5"
	class:top-0={content.position === 'top-left' || content.position === 'top-right'}
	class:left-0={content.position === 'top-left' || content.position === 'bottom-left'}
	class:right-0={content.position === 'top-right' || content.position === 'bottom-right'}
	class:bottom-0={content.position === 'bottom-left' || content.position === 'bottom-right'}
>
	{#each content.body as block}
		<Blok content={block} />
	{/each}
</div>
